import { FC, memo } from 'react'

import { RoovLogo } from 'src/components/atoms/logos/RoovLogo'

import { RoovLogoText } from './RoovLogoText'

type Props = {
  className?: string
}

export const LogoWithText: FC<Props> = memo(({ className }) => {
  return (
    <div className={className}>
      <div className="tw-grid tw-justify-items-center">
        <RoovLogo className="tw-w-[35%]" />
        <RoovLogoText textColor="dark" className="tw-w-full tw-mt-[16%]" />
      </div>
    </div>
  )
})
